import React, {useState} from 'react';
import { makeStyles, Hidden, Button } from '@material-ui/core';

import AddIcon from '@material-ui/icons/Add';

import { useOfflineAssets } from '../../offline/useOfflineAssets';
import { FirstLayerMenu } from './Components/FirstLayerMenu';

const useStyles = makeStyles(() => ({
    newButton: {
        color: "#FFF",
        fontWeight: 500,
        alignItems: "center",
        backgroundColor: "#1967d2",
        marginLeft: "26px",
        boxShadow: "0 1px 2px 0 rgba(60,64,67,0.302), 0 1px 3px 1px rgba(60,64,67,0.149)",
        '&:hover': {
            boxShadow: '0 1px 3px 0 rgba(60,64,67,0.302), 0 4px 8px 3px rgba(60,64,67,0.149)',
            backgroundColor: '#498bf8'
        },
        "&:disabled": {
            color: "rgba(0, 0, 0, 0.26)",
            backgroundColor: "rgba(0, 0, 0, 0.12)",
        },
        borderRadius: "24px",
        padding: "0 24px 0 24px",
        height: "48px",
        marginBottom: "12px",
        border: "1px solid rgba(60,64,67,0.202)",
        fontSize: "18px",
        textTransform: "capitalize"
    },
    addIcon: {
        marginRight: "8px",
        fontSize: "28px",
    },
}));

export function AddNewButton() {
    const classes = useStyles();
    const { onlineMode } = useOfflineAssets();
    const [anchor, setAnchor] = useState<HTMLElement>()

    return (
        <>
            <Hidden smDown>
                <Button
                    variant="contained" 
                    size="small" 
                    className={classes.newButton} 
                    onClick={(event) => setAnchor(event.currentTarget)} 
                    disabled={!onlineMode}
                >
                    <AddIcon className={classes.addIcon} />
                    Add New
                </Button>
            </Hidden>
            {anchor && <FirstLayerMenu anchorElement={anchor} onClose={() => setAnchor(undefined)} />}
        </>
    );
}